import styled from 'styled-components'

export const S169Container = styled.div`
  width: 100%;
  height: calc(100vw * 9 / 16);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-aspect-ratio: 1/1) {
    width: calc(100vh * 9 / 16);
    height: 100%;
  }
`
